import React, { useState, useEffect } from "react";
import ReactECharts from "echarts-for-react";
import { useHistory } from "react-router-dom";

import Grid from "../components/Grid";
import Table from "../components/Table";
import { Card, CardContent } from "../components/Card";
import Text from "../components/Text";

export default function StatisticalResults() {
  const history = useHistory();
  console.log(history.location.state);
  useEffect(() => {
    if (!Boolean(history.location.key)) {
      history.replace("/console/statistical");
    }
  }, [history]);

  const getOption = () => {
    if (history.location.state) {
      return {
        title: {
          text:
            (history.location.state.rangeObject &&
              history.location.state.rangeObject.label) +
            ":" +
            (history.location.state.auctionQuotesObject &&
              history.location.state.auctionQuotesObject.label),
          x: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        series: [
          {
            name: "來源",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            animationDuration: 5000,
            data: history.location.state.selectData,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
    }
  };
  const Option = () => {
    if (history.location.state) {
      return {
        xAxis: {
          type: "category",
          data: history.location.state.selectData.map((item) => {
            return item.name;
          }),
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: history.location.state.selectData.map((item) => {
              return item.value;
            }),
            type: "bar",
          },
        ],
      };
    }
  };

  const [newData, setNewData] = useState({
    page: 1,
    pageMax: null,
    pageSize: 10,
    pageArray: [],
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }

  return (
    <Card>
      <CardContent>
        <Grid container item spacing={1}>
          <Grid item xs={12} sm={6}>
            <Table
              stickyHeaderTop
              height={325}
              data={history.location.state.selectData}
              header={["類別", "坪"]}
              columns={[
                (item) => <Text>{item.name}</Text>,
                (item) => <Text>{item.value}&nbsp;萬元&nbsp;/&nbsp;坪</Text>,
              ]}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <ReactECharts option={getOption()} />
          </Grid>
        </Grid>
      </CardContent>
      <CardContent>
        <ReactECharts option={Option()} />
      </CardContent>
    </Card>
  );
}
